/**
 * @file: ReservedItemsCard.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The read-only list of confirmed lead items the visit is booked for — the
 * `预约项目` context the staff can't edit here.
 */

import { Typography } from '@euler/app/components/typography';
import { ReservationFormState } from '@euler/app/flows/leads/pages/create-reservation/functions/useReservationForm';
import { LeadItemTypeIcon } from '@euler/app/flows/leads/pages/detail/components/LeadItemTypeIcon';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { Card } from './common/Card';

export const ReservedItemsCard = ({
  items,
}: {
  items: ReservationFormState['confirmedItems'];
}) => {
  const { rpx } = useResponsiveContext();
  if (!items.length) {
    return (
      <Card>
        <View style={{ paddingVertical: rpx(16) }}>
          <Typography.Text size={rpx(14)} color={LD.mist}>
            暂无已确认项目
          </Typography.Text>
        </View>
      </Card>
    );
  }
  return (
    <Card>
      {items.map((item, index) => (
        <View
          key={item.id}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: rpx(12),
            borderTopWidth: index === 0 ? 0 : 1,
            borderTopColor: LD.hairline,
          }}
        >
          <View
            style={{
              width: rpx(38),
              height: rpx(38),
              borderRadius: rpx(19),
              backgroundColor: LD.brandSoft,
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: rpx(12),
            }}
          >
            <LeadItemTypeIcon
              type={item.type}
              size={rpx(26)}
              color={LD.brand}
            />
          </View>
          <View style={{ flex: 1, paddingRight: rpx(10) }}>
            <Typography.Text size={rpx(15)} color={LD.ink} bold>
              {item.name}
            </Typography.Text>
            {item.nextServiceDate ? (
              <Typography.Text size={rpx(12)} color={LD.mist} mt={rpx(3)}>
                建议 {item.nextServiceDate}
              </Typography.Text>
            ) : null}
          </View>
        </View>
      ))}
    </Card>
  );
};
